// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const HeaderSearch: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 19 20" width={width} height={height}>
            <path
                fill="currentColor"
                d="M14.25 8.094a6.531 6.531 0 1 0-13.063 0 6.531 6.531 0 0 0 13.063 0m-1.51 5.863a7.68 7.68 0 0 1-5.021 1.855A7.72 7.72 0 0 1 0 8.095 7.72 7.72 0 0 1 7.719.375a7.72 7.72 0 0 1 7.719 7.719 7.68 7.68 0 0 1-1.856 5.02l5.244 5.248c.23.23.23.609 0 .839a.596.596 0 0 1-.84 0z"
            />
        </svg>
    );
};

export default React.memo(HeaderSearch);
